import React from 'react';
import App from '../App';

const ExcelApp = () => {
  return <App />;
};

export default ExcelApp; 